namespace $ {

	$mol_style_define( $shm_projects_goal_output, {
		flex: { basis: '36rem', grow: 1, shrink: 1 },
		minWidth: '34rem',
		Title: {
			minHeight: 0,
			padding: 0,
		},
		Modes: {
			alignItems: 'center',
			gap: 0,
			minHeight: '2rem',
		},
		Body_content: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			height: '100%',
			maxHeight: '100%',
			minHeight: 0,
		},
	} )

}
